<template>
    <svg class="circle" :class="circle.class" version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" xml:space="preserve">
        <g>
        <circle x="100" y="100" r="100" />
        </g>
    </svg>
</template>
<script>
export default {
  props: ["circle"]
};
</script>
